// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3_iYf","tab":"ProcedureTabs_tab__3UOZb"};